import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 8 }
const _hoisted_7 = { key: 9 }

export function render(_ctx, _cache) {
  const _component_FormInput = _resolveComponent("FormInput")
  const _component_Button = _resolveComponent("Button")
  const _component_Img = _resolveComponent("Img")
  const _component_FormContainer = _resolveComponent("FormContainer")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('chat-modal-container'))
  }, [
    _createCommentVNode(" BUBBLE COMPONENT "),
    (_ctx.messageSettings && _ctx.messageSettings.modalLoadBehavior
				&& (_ctx.messageSettings.modalLoadBehavior === _ctx.LoadBehaviorEnum.PLACEHOLDER_ONLY
					|| _ctx.messageSettings.modalLoadBehavior === _ctx.LoadBehaviorEnum.AUTO_OPEN_WITH_PLACEHOLDER))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.getClass('bubble ') + _ctx.getClass('chat-modal-bubble')),
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.openModal && _ctx.openModal(...args)))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClass('bubble-label'))
          }, [
            _createElementVNode("p", null, _toDisplayString(_ctx.placeholderLabel), 1 /* TEXT */)
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClass('bubble-icon'))
          }, [
            (!!_ctx.isPlaceholderIconImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.placeholderIcon,
                  alt: _ctx.placeholderLabel,
                  style: _normalizeStyle(_ctx.iconImageStyle)
                }, null, 12 /* STYLE, PROPS */, _hoisted_1))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  innerHTML: _ctx.placeholderIcon,
                  style: _normalizeStyle(_ctx.iconImageStyle)
                }, null, 12 /* STYLE, PROPS */, _hoisted_2))
          ], 2 /* CLASS */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" MODAL COMPONENT "),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('chat-modal-backdrop ')
		+ ' ' + (!_ctx.showModal ? _ctx.getClass('hide-modal') : '')
		+ ' ' + ((_ctx.messageSettings && _ctx.messageSettings.style && _ctx.messageSettings.style == 'slide') ? _ctx.getClass('slide-fade') : '')
		+ ' ' + ((_ctx.messageSettings && _ctx.messageSettings.style && _ctx.messageSettings.style == 'center') ? _ctx.getClass('modal-center') : ''))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('chat-modal ')),
        role: "dialog",
        "aria-label": "Modal",
        ref: "chat_modal"
      }, [
        _createElementVNode("header", {
          class: _normalizeClass(_ctx.getClass('chat-modal-header')),
          role: "presentation"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { "aria-hidden": "true" }, " ", -1 /* HOISTED */)),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.getClass('btn-modal-close')),
            "aria-label": "Close modal",
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            title: "Close modal"
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
          ]), 2 /* CLASS */), [
            [_vShow, _ctx.messageSettings && _ctx.messageSettings.enableCloseIcon != null ? !!_ctx.messageSettings.enableCloseIcon : true]
          ])
        ], 2 /* CLASS */),
        _createElementVNode("section", {
          class: _normalizeClass(_ctx.getClass('chat-modal-body'))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderComponents, (component, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (component.type=='text')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.decodeTags(component.content)
                  }, null, 8 /* PROPS */, _hoisted_3))
                : (component.type=='html')
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: component.content
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : (component.type=='markdown')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 2,
                        innerHTML: _ctx.marked(component.content)
                      }, null, 8 /* PROPS */, _hoisted_5))
                    : (component.type=='input')
                      ? (_openBlock(), _createBlock(_component_FormInput, {
                          key: 3,
                          component: component
                        }, null, 8 /* PROPS */, ["component"]))
                      : (component.type=='button' || component.type=='link')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createCommentVNode(" Single button (not grouped) "),
                            _createVNode(_component_Button, {
                              component: component,
                              messageContentsettings: _ctx.messageContentsettings
                            }, null, 8 /* PROPS */, ["component", "messageContentsettings"])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (component.type=='button-group')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                              _createCommentVNode(" Button group (multiple consecutive buttons) "),
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.getClass('button-list')),
                                role: "list"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.items, (buttonItem, buttonIndex) => {
                                  return (_openBlock(), _createBlock(_component_Button, {
                                    key: buttonIndex,
                                    component: buttonItem,
                                    messageContentsettings: _ctx.messageContentsettings,
                                    isListItem: true
                                  }, null, 8 /* PROPS */, ["component", "messageContentsettings"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 2 /* CLASS */)
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                          : (component.type=='image')
                            ? (_openBlock(), _createBlock(_component_Img, {
                                key: 6,
                                component: component
                              }, null, 8 /* PROPS */, ["component"]))
                            : (component.type=='form')
                              ? (_openBlock(), _createBlock(_component_FormContainer, {
                                  key: 7,
                                  component: component,
                                  messageId: _ctx.messageId
                                }, null, 8 /* PROPS */, ["component", "messageId"]))
                              : (component.type=='line')
                                ? (_openBlock(), _createElementBlock("hr", _hoisted_6))
                                : (component.type=='break')
                                  ? (_openBlock(), _createElementBlock("br", _hoisted_7))
                                  : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}